import React, { Component } from 'react';
import { Home } from './components/Home';
import { SpellChecker } from './components/SpellChecker';
import "./App.css"
import { Route, Routes, useOutlet } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

const App = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<SpellChecker />} />
        </Routes>
      </div>
    </BrowserRouter>
  )
}
export default App;

